import { initCalendarMailboxConfiguration, initTxpSettings } from 'owa-calendar-configuration';
import { initCalendarProcessingOptions } from 'owa-calendar-processing-configuration';
import { trace } from 'owa-trace';

export default async function loadCalendarMailboxAndProcessingConfig(): Promise<boolean> {
    try {
        await Promise.all([
            initCalendarMailboxConfiguration(),
            initCalendarProcessingOptions(),
            initTxpSettings(),
        ]);
        return true;
    } catch (e) {
        trace.warn(e.message || 'loadCalendarMailboxAndProcessingConfig failed');
        return false;
    }
}
